<kendo-grid #grid [data]="gridView" [pageable]="total > state.take ? { buttonCount: 5, pageSizes: pageSizes } : false"
    [pageSize]="state.take" [skip]="state.skip" [loading]="loading" [sort]="state.sort" [filter]="state.filter"
    [sortable]="true" [filterable]="messageEnableAdvanced" [columnMenu]="messageEnableAdvanced" [resizable]="true"
    [reorderable]="messageEnableAdvanced" (dataStateChange)="dataStateChange($event)" [navigable]="true">
    <kendo-grid-messages noRecords="{{ 'NO-MESSAGES' | translate }}">
    </kendo-grid-messages>
    <kendo-grid-column field="from" title="{{ 'FROM' | translate }}"></kendo-grid-column>
    <kendo-grid-column field="to" title="{{ 'TO' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
            <span class="ellipsis-text" *ngFor="let to of dataItem.to;let i = index;"
                [innerHTML]="to.name | cleanAddress:i"></span>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="sentOn" title="{{ 'SENT-ON' | translate }}" filter="date" format="{0:d}">
        <ng-template kendoGridCellTemplate let-dataItem>
            <div *ngIf="dataItem.sentOn!==null">{{ intl.formatDate(intl.parseDate(dataItem.sentOn), 'g') }}</div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="subject" title="{{'SUBJECT' | translate}}" class="emphasizedLabel">
        <ng-template kendoGridCellTemplate let-dataItem>
            <a class="pointer" (click)="openMessageDetails(dataItem)">
                <strong>{{ dataItem.subject }}</strong>
            </a>
        </ng-template>
    </kendo-grid-column>
</kendo-grid>
<button kendoButton [primary]="true" (click)="composeMessage()" class="mt-3 mb-2 float-right mr-1" type="button">{{
    'COMPOSE' | translate }}<i class="far fa-envelope"></i>
</button>

<kendo-dialog *ngIf="messageDialogOpened" (close)="messageDialogOpened=false" [minWidth]="400" [width]="700">
    <kendo-dialog-titlebar>
        <h3>{{ 'NEW-MESSAGE' | translate}}</h3>
    </kendo-dialog-titlebar>
    <app-message-compose #messageCompose [messageDialogOpened]="messageDialogOpened" [memberId]="memberId"
        [caseId]="caseId" [messageList]="messageView" [fromMessagesScreen]="'member'" [sendTo]="messageSendTo"
        (afterSave)="closeDialogAndRefresh()" (saving)="savingMessage=$event;messageDialogOpened=false">
    </app-message-compose>
    <kendo-dialog-actions>
        <button kendoButton (click)="messageDialogOpened = false" [disabled]="savingMessage">{{ 'CANCEL' | translate
            }}</button>
        <button appPreventClick #submitButton kendoButton type="button"
            [disabled]="!messageCompose.formValid() || savingMessage" (click)="messageCompose.save($event);">
            {{'SEND' | translate}}<i class="fal fa-paper-plane"></i>
        </button>
    </kendo-dialog-actions>
</kendo-dialog>

<!-- open message details dialog -->
<kendo-dialog *ngIf="messageDetailDialogOpened" (close)="messageDetailDialogOpened = false" [width]="1024">
    <kendo-dialog-titlebar>
        <h3>{{'MESSAGE' | translate}}</h3>
    </kendo-dialog-titlebar>
    <div class="content-background" style="padding:0px;">
        <app-message-detail [message]="selectedMessage"></app-message-detail>
    </div>
    <kendo-dialog-actions>
        <button kendoButton (click)="messageDetailDialogOpened = false">{{ 'CLOSE' | translate }}</button>
    </kendo-dialog-actions>
</kendo-dialog>